// extracted by css-extract-rspack-plugin
export default {"control":"ResizerHorizontal_control__dKMUZ","dragging":"ResizerHorizontal_dragging__NvCtp"};